export const Article = "article";
export const Homepage = "homepage";
export const NotFound = "404";
export const Brochure = "brochure";
export const Content = "content";
export const Series = "series";